import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { TrainingTemplateDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { Form } from 'modules/trainings/components/Revamp/Form'

const TrainingTemplateDetails = () => {
  const { templateId } = useParams<{ templateId: string }>()
  const { data, loading, error } = useQuery(TrainingTemplateDocument, {
    variables: { id: templateId ?? '' },
  })

  const trainingForm = data?.forms.form ?? undefined
  const [openSidepanel, setOpenSidepanel] = useState<boolean>(false)

  return (
    <ResponsivePage.Body loading={loading} error={error} variant="fullscreen">
      <Form
        openSidepanel={openSidepanel}
        setOpenSidepanel={setOpenSidepanel}
        trainingForm={trainingForm}
      />
    </ResponsivePage.Body>
  )
}

export default TrainingTemplateDetails
